/*-----------------------------------------------------------------------------------
    Template Name: Kiddyfun
    Description: Kids Toys Store and Baby Shop HTML5 Template
    Author: Codezion
    Author URI: https://www.templatemonster.com/authors/codezion/
    Version: 1.0
-----------------------------------------------------------------------------------*/
(function($) {
    'use strict';
    $(".hamburger>.hamburger_btn").on('click', function() {
        $(".header .navigation").toggleClass('open');
        $(this).toggleClass('active');
    });
    $(window).on('load', function() {
        $(document).ready(function() {
             $(".animated-dashes").append("<svg class='inner-dashed-border' height='100%' width='100%' preserveAspectRatio='none'><rect  width='100%' height='100%'></rect></svg>");
        });
    });
    // Mobile Menu
    $(".header .menu-item-has-children > a").on('click', function(e) {
        var submenu = $(this).next(".sub-menu");
        e.preventDefault();
        submenu.slideToggle(200);
    });
    // search trigger
    $(".search-trigger").on('click', function(e) {
        e.preventDefault();
        $(".search-form-wrapper").toggleClass('open');
    });
    // collection filter drawer
    $("[data-collection-drawer-toggle]").on('click', function() {
        $(".template-collection").addClass('kiddy-collection-drawer-open');
        $("body").addClass('kiddy-collection-drawer-lock');
    });
    $("[data-collection-drawer-close]").on('click', function() {
        $(".template-collection").removeClass('kiddy-collection-drawer-open');
        $("body").removeClass('kiddy-collection-drawer-lock');
    });
    $(document).on('keyup', function(e) {
        if (e.key === 'Escape') {
            $(".template-collection").removeClass('kiddy-collection-drawer-open');
            $("body").removeClass('kiddy-collection-drawer-lock');
        }
    });
    $(window).on('resize', function() {
        if (window.innerWidth > 991) {
            $(".template-collection").removeClass('kiddy-collection-drawer-open');
            $("body").removeClass('kiddy-collection-drawer-lock');
        }
    });
    // testimonials_slider
    $('.testimonials_slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: true,
        dotsClass: "slick-dots d-flex mt-5",
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }]
    });
    // product details
    $('.product_slider').slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.product_slider_nav'
    });
    $('.product_slider_nav').slick({
        dots: false,
        arrows: false,
        vertical: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        verticalSwiping: true,
        asNavFor: '.product_slider',
        responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                    verticalSwiping: false,
                    vertical: false
                }
            }
        ]
    });
    function bindProductMediaSticky() {
        var productSections = Array.prototype.slice.call(document.querySelectorAll('.template-product .kiddy-sticky-product'));
        if (!productSections.length) return;
        var desktopQuery = window.matchMedia('(min-width: 992px)');
        var ticking = false;

        function clearSticky(section) {
            var gallery = section.querySelector('.kiddy-sticky-product__gallery');
            var inner = section.querySelector('.kiddy-sticky-product__gallery-inner');
            if (!gallery || !inner) return;
            inner.style.transform = '';
            gallery.style.minHeight = '';
        }

        function updateSticky() {
            ticking = false;

            productSections.forEach(function(section) {
                var gallery = section.querySelector('.kiddy-sticky-product__gallery');
                var inner = section.querySelector('.kiddy-sticky-product__gallery-inner');
                if (!gallery || !inner) return;

                if (!desktopQuery.matches) {
                    clearSticky(section);
                    return;
                }

                var sectionRect = section.getBoundingClientRect();
                var sectionTop = window.scrollY + sectionRect.top;
                var sectionHeight = section.offsetHeight;
                var innerHeight = inner.offsetHeight;
                var stickyHeader = document.querySelector('.can-sticky');
                var headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
                var stickyTop = Math.max(headerOffset + 24, 40);
                var maxTranslate = Math.max(sectionHeight - innerHeight, 0);
                var start = sectionTop - stickyTop;
                var end = start + maxTranslate;
                var translate = 0;

                if (window.scrollY > start) {
                    translate = window.scrollY >= end ? maxTranslate : (window.scrollY - start);
                }

                gallery.style.minHeight = innerHeight + translate + 'px';
                inner.style.transform = 'translate3d(0, ' + Math.max(0, translate) + 'px, 0)';
            });
        }

        function requestStickyUpdate() {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(updateSticky);
        }

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate);
        window.addEventListener('load', requestStickyUpdate);
    }
    bindProductMediaSticky();
    // Sticky Header
    var header = $(".can-sticky");
    var footer = $(".ft-sticky");
    var headerHeight = header.innerHeight();
    var FooterHeight = footer.innerHeight();

    function doSticky() {
        if (window.pageYOffset > headerHeight) {
            header.addClass("sticky");
        } else {
            header.removeClass("sticky");
        }
        if (window.pageYOffset > FooterHeight) {
            footer.addClass("d-flex");
        } else {
            footer.removeClass("d-flex");
        }
    }
    doSticky();
    //On scroll events
    $(window).on('scroll', function() {
        doSticky();
    });
    if ($(".back-to-top").length) {
        $(".back-to-top").on("click", function() {
            var target = $(this).attr("data-target");
            // animate
            $("html, body").animate({
                    scrollTop: $(target).offset().top,
                },
                1000
            );

            return false;
        });
    };
    $('.popup-video').magnificPopup({
        type: 'iframe',
    });
    $('.popup-image').magnificPopup({
        type: 'image',
    });
    // Current year
    var d = new Date();
    document.getElementById("year").innerHTML = d.getFullYear();
    // Range Slider
    $(function() {
        $("#slider-range").slider({
            range: true,
            min: 0,
            max: 500,
            values: [75, 300],
            slide: function(event, ui) {
                $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
            }
        });
        $("#amount").val("$" + $("#slider-range").slider("values", 0) +
            " - $" + $("#slider-range").slider("values", 1));
    });
    // Add / Subtract Quantity
    $(".quantity button").on('click', function() {
        if ($(this).closest('[data-qty-target]').length) {
            return;
        }
        var qty = $(this).closest('.quantity').find('input');
        var qtyVal = parseInt(qty.val());
        if ($(this).hasClass('qty-add')) {
            qty.val(qtyVal + 1);
        } else {
            return qtyVal > 1 ?
                qty.val(qtyVal - 1) :
                0;
        }
    });
    // Toggle eye
    function VisiblePassword() {
        document.querySelectorAll('[data-password-toggle]').forEach(function(togglePassword) {
            var password = document.querySelector(togglePassword.getAttribute('data-password-toggle'));
            if (!password) return;
            togglePassword.addEventListener('click', function() {
                var type = password.getAttribute('type') === 'password' ? 'text' : 'password';
                password.setAttribute('type', type);
                this.classList.toggle('fa-eye-slash');
            });
        });
        var togglePassword = document.querySelector('#password_eye');
        var password = document.querySelector('#password_value');
        if (togglePassword && password && !togglePassword.hasAttribute('data-password-toggle')) {
            togglePassword.addEventListener('click', function() {
                var type = password.getAttribute('type') === 'password' ? 'text' : 'password';
                password.setAttribute('type', type);
                this.classList.toggle('fa-eye-slash');
            });
        }
    }
    VisiblePassword();
    function bindQuickView() {
        var modalElement = document.getElementById('shopModal');
        if (!modalElement) return;
        var image = modalElement.querySelector('[data-quickview-image]');
        var title = modalElement.querySelector('[data-quickview-title]');
        var description = modalElement.querySelector('[data-quickview-description]');
        var price = modalElement.querySelector('[data-quickview-price]');
        var comparePrice = modalElement.querySelector('[data-quickview-compare-price]');
        var sku = modalElement.querySelector('[data-quickview-sku]');
        var category = modalElement.querySelector('[data-quickview-category]');
        var tags = modalElement.querySelector('[data-quickview-tags]');
        var productLinks = modalElement.querySelectorAll('[data-quickview-product-link]');

        document.querySelectorAll('[data-kiddy-quickview]').forEach(function(trigger) {
            trigger.addEventListener('click', function() {
                var productTitle = this.getAttribute('data-product-title') || '';
                var productUrl = this.getAttribute('data-product-url') || '#';
                var productImage = this.getAttribute('data-product-image') || '';
                var productPrice = this.getAttribute('data-product-price') || '';
                var productComparePrice = this.getAttribute('data-product-compare-price') || '';
                var productDescription = this.getAttribute('data-product-description') || '';
                var productCategory = this.getAttribute('data-product-category') || '<p>Empfohlen</p>';
                var productSku = this.getAttribute('data-product-sku') || 'N/A';
                var productTags = this.getAttribute('data-product-tags') || '<p>Spielzeug</p>';

                if (image) {
                    image.src = productImage;
                    image.alt = productTitle;
                }
                if (title) {
                    title.textContent = productTitle;
                }
                if (description) {
                    description.textContent = productDescription;
                }
                if (price) {
                    price.textContent = productPrice;
                }
                if (comparePrice) {
                    comparePrice.textContent = productComparePrice;
                    comparePrice.hidden = !productComparePrice;
                }
                if (sku) {
                    sku.textContent = productSku;
                }
                if (category) {
                    category.innerHTML = productCategory;
                }
                if (tags) {
                    tags.innerHTML = productTags;
                }
                productLinks.forEach(function(link) {
                    link.setAttribute('href', productUrl);
                });
            });
        });
    }
    function bindQuickAdd() {
        document.querySelectorAll('[data-kiddy-quick-add]').forEach(function(form) {
            form.addEventListener('submit', function(event) {
                event.preventDefault();
                var submitButton = form.querySelector('button[type="submit"]');
                if (!submitButton || submitButton.disabled) return;
                var defaultText = submitButton.getAttribute('data-add-to-cart-default') || submitButton.textContent.trim();
                var addedText = submitButton.getAttribute('data-add-to-cart-added') || 'Zum Warenkorb hinzugefügt';
                var errorText = submitButton.getAttribute('data-add-to-cart-error') || 'Nicht verfügbar';
                submitButton.disabled = true;
                submitButton.textContent = 'Wird hinzugefügt...';

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json'
                    },
                    body: new FormData(form)
                })
                .then(function(response) {
                    if (!response.ok) {
                        throw new Error('In den Warenkorb legen fehlgeschlagen');
                    }
                    return response.json();
                })
                .then(function() {
                    submitButton.textContent = addedText;
                    window.setTimeout(function() {
                        submitButton.disabled = false;
                        submitButton.textContent = defaultText;
                    }, 1800);
                })
                .catch(function() {
                    submitButton.textContent = errorText;
                    window.setTimeout(function() {
                        submitButton.disabled = false;
                        submitButton.textContent = defaultText;
                    }, 1800);
                });
            });
        });
    }
        function bindHeaderLocalization() {
        var wrappers = document.querySelectorAll('[data-header-localization]');
        if (!wrappers.length) return;

        wrappers.forEach(function(wrapper) {
            var groups = wrapper.querySelectorAll('[data-localization-group]');

            function closeAll(exceptGroup) {
                groups.forEach(function(group) {
                    var toggle = group.querySelector('[data-localization-toggle]');
                    var menu = group.querySelector('[data-localization-menu]');
                    var shouldKeepOpen = exceptGroup && group === exceptGroup;

                    group.classList.toggle('is-open', !!shouldKeepOpen);
                    if (toggle) toggle.setAttribute('aria-expanded', shouldKeepOpen ? 'true' : 'false');
                    if (menu) menu.hidden = !shouldKeepOpen;
                });
            }

            groups.forEach(function(group) {
                var toggle = group.querySelector('[data-localization-toggle]');
                if (!toggle) return;

                toggle.addEventListener('click', function(event) {
                    event.preventDefault();
                    var isOpen = group.classList.contains('is-open');
                    closeAll(isOpen ? null : group);
                });
            });

            document.addEventListener('click', function(event) {
                if (!wrapper.contains(event.target)) {
                    closeAll(null);
                }
            });

            document.addEventListener('keyup', function(event) {
                if (event.key === 'Escape') {
                    closeAll(null);
                }
            });
        });
    }


    bindQuickView();
    bindQuickAdd();
    bindHeaderLocalization();
})(jQuery);
